
export const whatsApp = ['com.whatsapp']
export const wechat = ['com.tencent.mm']
export const samsungMessenger = ['com.samsung.android.messaging']
export const sms = ['com.android.mms']

export const whatsAppIcon = ['fab', 'whatsapp']
export const wechatIcon = ['fab', 'weixin']
export const genericIcon = 'comment'
export const samsungMessengerIcon = 'fa-duotone fa-message-dots'
export const smsIcon = "fa-duotone fa-message-sms"

export const supportedIMApps = {
  wechat: {
    name: 'WeChat',
    packages: wechat,
    icon: wechatIcon,
    iconClass: `has-text-${chatAppVariant(wechat[0])}`
  },
  whatsapp: {
    name: 'WhatsApp',
    packages: whatsApp,
    icon: whatsAppIcon,
    iconClass: `has-text-${chatAppVariant(whatsApp[0])}`
  },
  samsungMessenger: {
    name: 'Samsung Messenger',
    packages: samsungMessenger,
    icon: samsungMessengerIcon,
    iconClass: `has-text-${chatAppVariant(samsungMessenger[0])}`
  },
}

export const notificationEventTypes = ['NotificationReceived', 'NotificationStateChanged']
export const messageForwardedEventTypes = ['MessageForwarded']
export const massSentMessageEventType = 'MassSendMessage'

export function chatAppIcon (packageName) {
  if (whatsApp.includes(packageName)) return whatsAppIcon
  if (wechat.includes(packageName)) return wechatIcon
  if (samsungMessenger.includes(packageName)) return samsungMessengerIcon
  if (sms.includes(packageName)) return smsIcon
  return genericIcon
}

export function chatAppVariant (packageName) {
  if (whatsApp.includes(packageName)) return 'success'
  if (wechat.includes(packageName)) return 'success'
  if (samsungMessenger.includes(packageName)) return 'info'
  if (sms.includes(packageName)) return 'dark'
  return 'info'
}